import style from './styles/MainArea.scss';
import { Mobile } from '../../../helpers/MediaQueries';
import IntroductionArea from './IntroductionArea';
import RaffleService from '../../../services/RaffleService';

import classNames from 'classnames';

const MainArea = ({ raffle, lang }) => (
	<div className={style['main-area']}>
		<Mobile>
			<IntroductionArea raffle={raffle} />
		</Mobile>
		<p>{raffle.description}</p>
		<div className={style.gallery}>
			{raffle.images.map((image, index) => {
				const isFullWidth = index % 3 === 0;
				const shouldBeFullWidth = (index + 2) % 3 === 0 && index === raffle.images.length - 1;

				return (
					<img
						src={RaffleService.getImageUrl(image)}
						className={classNames("img-thumbnail",
							isFullWidth || shouldBeFullWidth ? style['full-width'] : style['half-width']
						)}
						alt={raffle.getTitle(lang)}
					/>
				)
			})}
		</div>
	</div>
);

export default MainArea;


// WEBPACK FOOTER //
// ./components/blocks/raffleDetail/MainArea.js